import ShowMoreText from 'react-show-more-text';
import {
  AnsHelpful,
  AnswerTopSection,
  HelpfulCTA,
  MostHelpfulRibbon,
  UserAnswer,
  UserDetails,
  UserImageIcon,
  UserImageIconGroup,
  UserImagesCollapsed,
} from './styled';
import {
  clicked_cta_event,
  clicked_helpful_count,
  getInsideParanthesisText,
} from '../../../Utils/questionUtils';
import { downloadAppHandler } from '../../../Utils/redirections';
import { getBranchLink } from '../../../Utils/helper';
import { letters, randomColor } from '../../../Constants/QuestionPage';
import { useEffect, useMemo, useState } from 'react';
import { randomOrder } from '../../StoreCategoryPage/CDPageLiveCount/constant';

export default function QAnswer(props) {
  const {
    data,
    installLink,
    key,
    contentId,
    allComments,
    loadCount,
    postData,
    most_helpful_comment_index,
  } = props;
  const comment_id = data?.id;
  const profileLetter = letters[comment_id % letters.length];
  const profileColor = randomColor[comment_id % randomColor.length];
  const helpful_count = data?.comment_like_length || 0;

  const letters_order = useMemo(
    () => randomOrder(letters, Math.min(4, helpful_count)),
    [],
  );

  const colors_order = useMemo(() => randomOrder(randomColor), []);

  const [showSection, setShowSection] = useState(false);

  const pregnancy_week = data?.propertytags?.weekPreg;
  const followers_count =
    (data?.user_details?.followers || 0) + (comment_id % 50);
  useEffect(() => {
    setShowSection(true);
  }, []);

  return (
    <UserAnswer key={key}>
      <div className="answerSection">
        {most_helpful_comment_index ? (
          <MostHelpfulRibbon>Most Helpful</MostHelpfulRibbon>
        ) : null}
        <div className="answerPadding">
          <AnswerTopSection>
            <UserImageIcon bg={profileColor}>{profileLetter}</UserImageIcon>
            <UserDetails>
              <div>{getInsideParanthesisText(pregnancy_week)}</div>
              <span>
                {followers_count} followers.{' '}
                <span
                  className="highlight"
                  onClick={() => {
                    downloadAppHandler();
                    clicked_cta_event(
                      'Comments',
                      'Follow',
                      postData?.object_id,
                      getBranchLink(),
                      'cta',
                      comment_id,
                    );
                  }}
                >
                  Follow
                </span>
              </span>
            </UserDetails>
          </AnswerTopSection>
          <ShowMoreText
            lines={4}
            more="See more"
            less="see less"
            expanded={false}
            anchorClass="seemore_selected"
          >
            <a className="light" onClick={(e) => e.preventDefault()}>
              A:{' '}
            </a>

            <span>{data?.message}</span>
          </ShowMoreText>
          <AnsHelpful>
            <HelpfulCTA
              onClick={() => {
                downloadAppHandler();
                clicked_helpful_count(
                  'Helpful Section',
                  getBranchLink(),
                  data?.id,
                  contentId,
                );
              }}
            >
              <img loading="lazy" src="/images/thumbs_up.svg" alt="" />
              <a>
                <span className="helpFul">Helpful</span>{' '}
              </a>
            </HelpfulCTA>

            {helpful_count > 0 ? <span>{helpful_count}</span> : null}
            {showSection ? (
              <UserImagesCollapsed>
                {letters_order.map((letter, index) => (
                  <UserImageIconGroup
                    position={index}
                    bgColor={colors_order[index]}
                    key={index}
                  >
                    {letter}
                  </UserImageIconGroup>
                ))}
              </UserImagesCollapsed>
            ) : null}
          </AnsHelpful>
        </div>
      </div>
    </UserAnswer>
  );
}
